import { c as _c } from "react/compiler-runtime";
import { EntryInfo, entryHref, spaceName } from '../utils';
import css from './entry-list.module.scss';
export function EntryList(t0) {
  const $ = _c(6);
  const {
    entries
  } = t0;
  let t1;
  if ($[0] !== entries) {
    let t2;
    if ($[2] !== entries.length) {
      t2 = (entry, idx) => {
        const href = entryHref(entry);
        return <div key={entry.id}><div className={css.entry}>{entry.title && (href ? <a className={css.title} href={href} target="_blank" rel="noreferrer">{entry.title}</a> : <span className={css.title}>{entry.title}</span>)}<div className={css.meta}>{entry.contentType && <span className={css.type}>◈ {entry.contentType}</span>}{entry.environment && <span className={css.badge}>◉ {entry.environment}</span>}{entry.spaceId && <span className={css.space} title={entry.spaceId}>⊞ {spaceName(entry.spaceId)}</span>}</div></div>{idx < entries.length - 1 && <div className={css.divider} />}</div>;
      };
      $[2] = entries.length;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = entries.map(t2);
    $[0] = entries;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className={css.list}>{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}